export const AUTH_USER = "AUTHENTICATED";
export const POST_USER = "POST_USER";
export const LIST_USER = "LIST_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const AUTH_WITH_SSO = "AUTH_WITH_SSO";
